var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex mt-16 align-center justify-center"},[(!_vm.error)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50}}):_c('BaseParagraph',{staticClass:"error--text"},[_vm._v(" Une erreur s'est produite ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }